import React from "react"
import { connect } from "react-redux"
import * as actionCreators from "../redux/action_creators"
import { parse } from "query-string"
import { getToken } from "../util/jwt_utils"
import Logo from "../components/logo"
export const apiHost = process.env.REACT_APP_API_ENDPOINT

export class OAuthAuthorization extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        const query = parse(this.props.location.search)
        const { client_id, response_type, scope, state, client_name } = query
        this.setState({
            client_id,
            response_type,
            scope,
            state,
            client_name,
        })
    }

    render() {
        const {
            client_name,
            response_type,
            client_id,
            redirect_uri,
            scope,
            state,
        } = this.state
        const token = getToken()

        const hiddenFields = [
            { value: token, id: "token" },
            { value: response_type, id: "response_type" },
            { value: client_id, id: "client_id" },
            { value: redirect_uri, id: "redirect_uri" },
            { value: scope, id: "scope" },
            { value: state, id: "state" },
        ]

        return (
            <div className="authorization-wrapper">
                <Logo />
                <h2 className="title">{client_name} Authorization</h2>
                <p className="subtitle">
                    An application would like to connect to your account.
                </p>

                <p className="auth-msg">
                    The app <b>{client_name}</b> would like the ability to
                    access your <b>Shoutbase</b> account on your behalf.
                </p>

                <div className="allow-access">
                    <p className="allow-access">
                        Allow <b>{client_name}</b> access?
                    </p>
                    <form
                        action={`${apiHost}/oauth/authorization`}
                        method="post"
                    >
                        {hiddenFields.map(field => {
                            const { id, value } = field
                            return (
                                <input
                                    type="hidden"
                                    id={id}
                                    key={id}
                                    name={id}
                                    value={value}
                                />
                            )
                        })}
                        <div className="btn-row">
                            <button
                                type="submit"
                                name="operation"
                                value="allow"
                                className="btn btn-primary"
                            >
                                Allow
                            </button>
                            <button
                                type="submit"
                                name="operation"
                                value="deny"
                                className="btn btn-default"
                            >
                                Deny
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return state
}
export default connect(
    mapStateToProps,
    actionCreators,
)(OAuthAuthorization)



// WEBPACK FOOTER //
// ./src/pages/oauth_authorization.jsx